// @ts-nocheck
/* eslint-disable */
export const boldMinusCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1.333C4.326 1.333 1.333 4.327 1.333 8S4.326 14.667 8 14.667 14.666 11.673 14.666 8 11.673 1.333 8 1.333M10.613 8.5H5.28a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h5.333a.5.5 0 1 1 0 1"/></svg>`,
    name: 'bold-minus-circle' as const
};